
import { useTranslation } from 'react-i18next';
import { translateTabName } from 'helpers';
import styles from './../../layouts/config-view/config-detail/dashboards/ConfigLayoutDashboards.module.css';

interface ValidationErrorBarProps {
  tabsWithErrors: string[];
}

export const ValidationErrorBar = ({ tabsWithErrors }: ValidationErrorBarProps) => {
  const { t } = useTranslation();
  if (tabsWithErrors.length === 0) return null;
  return (
    <div className={`alert alert-danger d-flex align-items-center gap-2 mb-0 rounded-0 border-start-0 border-end-0 ${styles.alertBar}`} role="alert">
      <span className={`material-icons ${styles.alertIcon}`}>error_outline</span>
      <span>
        <strong>{t('VALIDATION.FIX_ERRORS_BEFORE_SAVING')}</strong>{' '}{t('VALIDATION.TABS_WITH_ISSUES')}{' '}
        {tabsWithErrors.map((name) => translateTabName(name, t)).join(', ')}
      </span>
    </div>
  );
};